import { Route, Routes } from 'react-router-dom';
import { E2nApiApolloProvider } from './lib/ApolloClient';
import { E2nApiAuthProvider } from './lib/E2nApiAuthContext';
import type { E2nApiAuthContextValue } from './lib/E2nApiAuthContext';
import { Layout } from './pages/Layout.tsx';
import { ZugaengePage } from './pages/ZugaengePage.tsx';
import { NeuerZugangPage } from './pages/NeuerZugangPage.tsx';
import { ZugangBearbeitenPage } from './pages/ZugangBearbeitenPage.tsx';

export type E2nApiProps = E2nApiAuthContextValue;

export function E2nApi(props: E2nApiProps) {
  return (
    <E2nApiAuthProvider value={props}>
      <E2nApiApolloProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<ZugaengePage />} />
            <Route path="zugang/neu" element={<NeuerZugangPage />} />
            <Route
              path="zugang/:uidZugang/bearbeiten"
              element={<ZugangBearbeitenPage />}
            />
          </Route>
        </Routes>
      </E2nApiApolloProvider>
    </E2nApiAuthProvider>
  );
}
